import { GtmListIdSchema, GtmListNameSchema } from './list-types';
import { Schema } from 'effect';

import { GtmItemsArraySchema } from './items';

/**
 * Triggered when a user selects an item from a list
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm#select_item_details
 */
export const GtmSelectItemEventSchema = Schema.Struct({
  event: Schema.Literal('select_item'),
  ecommerce: Schema.Struct({
    item_list_id: GtmListIdSchema,
    item_list_name: GtmListNameSchema,
    items: GtmItemsArraySchema,
  }),
}).annotate({ identifier: 'GtmSelectItemEventSchema' });

export type GtmSelectItemEvent = Schema.Schema.Type<typeof GtmSelectItemEventSchema>;
